/* Contenus éditables : comparatif, ingrédients et vitamines. */
(() => {
  const initialized = new WeakSet();
  function init(scope) {
    const comparison = scope.matches?.('.comparison') ? scope : scope.querySelector('.comparison');
    if (comparison && !initialized.has(comparison)) {
      initialized.add(comparison);
      const rows = [...comparison.querySelectorAll('.compare-row')];
      const filters = [...comparison.querySelectorAll('[data-filter]')];
      filters.forEach(button => button.addEventListener('click', () => {
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        rows.forEach(row => { row.hidden = button.dataset.filter !== 'all' && row.dataset.category !== button.dataset.filter; });
        const count = rows.filter(row => !row.hidden).length;
        const status = comparison.querySelector('#comparison-status');
        status.textContent = status.dataset.statusText.replace('{count}', count);
      }));
    }
    const root = scope.matches?.('.formula-explorer') ? scope : scope.querySelector('.formula-explorer');
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    const buttons = [...root.querySelectorAll('[data-explore]')];
    const vitaminButtons = [...root.querySelectorAll('[data-vitamin]')];
    const photo = root.querySelector('#explorer-image');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let animation;
    motion.addEventListener('change', event => { if (event.matches) animation?.cancel(); });
    buttons.forEach(button => button.addEventListener('click', () => {
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.dataset.selected = button.dataset.explore;
      photo.src = button.dataset.exploreImage;
      photo.alt = button.dataset.exploreAlt;
      for (const name of ['caption', 'label', 'name', 'description', 'dose']) {
        root.querySelector('#explorer-' + name).textContent = button.dataset['explore' + name[0].toUpperCase() + name.slice(1)];
      }
      root.querySelector('#explorer-vitamins').hidden = button.dataset.explore !== 'vitamins';
      animation?.cancel();
      if (!motion.matches) animation = photo.animate([{ opacity: .5 }, { opacity: 1 }], { duration: 220 });
    }));
    vitaminButtons.forEach(button => button.addEventListener('click', () => {
      vitaminButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelector('#vitamin-note').textContent = button.dataset.vitaminNote;
      root.querySelector('#vitamin-detail-title').textContent = button.dataset.vitaminTitle;
    }));
    [buttons, vitaminButtons].forEach(group => group.forEach((button, index) => {
      button.addEventListener('keydown', event => {
        const direction = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
        if (direction === undefined && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? group.length - 1 : (index + direction + group.length) % group.length;
        group[next].focus(); group[next].click();
      });
    }));
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
